import MyAccountSettingsV2 from './MyAccountSettingsV2'

export default MyAccountSettingsV2
// eslint-disable-next-line import/export
export * from './MyAccountSettingsV2'
